import { render, staticRenderFns } from "./MarketSectorEdit.vue?vue&type=template&id=4154e620&scoped=true"
import script from "./MarketSectorEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketSectorEdit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4154e620",
  null
  
)

export default component.exports